enum BillingPaymentMethod {
    Cash = 0,
    DebitCard = 1,
    Visa = 2,
    Check = 3,
    AmericanExpress = 4,
    MasterCard = 5,
    OnlinePayment = 6,
    Payable = 7,
    Receivable = 8,
    ElectronicFunds = 9,
    Other = 10
}

export { BillingPaymentMethod };
